import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-web-developer-contact-us',
  templateUrl: './web-developer-contact-us.component.html',
  styleUrls: ['./web-developer-contact-us.component.css']
})
export class WebDeveloperContactUsComponent implements OnInit {
  contactForm: FormGroup;
  name: FormControl = new FormControl('', [Validators.required]);
  email: FormControl = new FormControl('', [Validators.required, Validators.email]);
  phone: FormControl = new FormControl('', [Validators.required]);
  subject: FormControl = new FormControl('', [Validators.required]);
  message: FormControl = new FormControl('', [Validators.required, Validators.maxLength(256)]);
  honeypot: FormControl = new FormControl('');
  submitted = false;
  isLoading = false;
  responseMessage: string;

  profile: any = {
    logo: "logo-black-5.png",
    profile: "web-developer"
  };

  page_banner: any = {
    title: "Contact Me",
    profile: "web-developer",
  };

  constructor(
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.contactForm = this.fb.group({
      name: this.name,
      email: this.email,
      phone: this.phone,
      subject: this.subject,
      message: this.message,
      honeypot: this.honeypot
    });
  }

  ngOnInit(): void {
  }

  onSubmit() {
    if (this.contactForm.status === 'VALID' && this.honeypot.value === '') {
      this.contactForm.disable();
      const formData = new FormData();
      formData.append('name', this.contactForm.get('name').value);
      formData.append('email', this.contactForm.get('email').value);
      formData.append('phone', this.contactForm.get('phone').value);
      formData.append('subject', this.contactForm.get('subject').value);
      formData.append('message', this.contactForm.get('message').value);
      this.isLoading = true;
      this.submitted = false;
      this.http.post('https://script.google.com/macros/s/AKfycbzMloGNI9ARoi--0oaQ5EpNfhoB66m7GUhMKcrX1g/exec', formData).subscribe(
        (response) => {
          if (response['result'] === 'success') {
            this.responseMessage = 'Thanks for the message! I\'ll get back to you soon!';
          } else {
            this.responseMessage = 'Oops! Something went wrong... Reload the page and try again.';
          }
          this.contactForm.enable();
          this.submitted = true;
          this.isLoading = false;
          console.log('response', response);
        },
        (error) => {
          this.responseMessage = 'Oops! An error occured... Reload the page and try again.';
          this.contactForm.enable();
          this.submitted = true;
          this.isLoading = false;
          console.log('error', error);
        }
      );
    }
  }

}
